import api from '../api'

export default {
  getCount (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.get('api/appclient/v2/shopcart/getCount', data, successCallback, errCallback, isShowErrMsg)
  },
  addToCart (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.post('api/appclient/v2/shopcart/add', data, successCallback, errCallback, isShowErrMsg)
  },
  updateExtra (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.post('api/appclient/v2/cart/doGoodsExtra', data, successCallback, errCallback, isShowErrMsg)
  },
  delCartItem (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.post('api/appclient/v2/shopcart/delete', data, successCallback, errCallback, isShowErrMsg)
  },
  getCartInfo (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.get('api/appclient/v2/shopcart/list', data, successCallback, errCallback, isShowErrMsg)
  },
  getPartList (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.get('api/appclient/v2/product/getParts', data, successCallback, errCallback, isShowErrMsg)
  },
  updateCartItem (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.post('api/appclient/v2/shopcart/update', data, successCallback, errCallback, isShowErrMsg)
  }, 
  updateCheckItem (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.post('api/appclient/v2/shopcart/check', data, successCallback, errCallback, isShowErrMsg)
  },
  getFirmOrderAddress (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.get('api/appclient/v2/user/address/order', data, successCallback, errCallback, isShowErrMsg)
  },
  getFirmOrder (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.get('api/appclient/v2/shopcart/getPreOrderInfos', data, successCallback, errCallback, isShowErrMsg)
  },
  getDeliveryTimer (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.post('api/appclient/v2/goods/skuDeliveryTime', data, successCallback, errCallback, isShowErrMsg)
  },
  submitOrder (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.post('api/appclient/v2/order/submitOrder', data, successCallback, errCallback, isShowErrMsg)
  },
  goOrder (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.post('api/appclient/v2/shopcart/toSettlement', data, successCallback, errCallback, isShowErrMsg)
  }
}



// WEBPACK FOOTER //
// ./src/api/shopCart/api.shopCart.js